import AlphaBankForm from './alphabank';
import PiraeusBankForm from './piraeusbank';

const CardForms = () => {
    return (
        <>
            <AlphaBankForm />
            <PiraeusBankForm />
        </>
    );
};

export default CardForms;
